$(document).ready(() => {
  $(document).on("click", ".icon-to-manage-menu-close", function () {
    closeMenu();
  });

  function closeMenu() {
    hideElement("custom-display-menu-opened", true);
    hideElement("custom-display-menu-closed", false);

    $("#div-with-page-content")
      .removeClass("custom-display-screen-menu-open")
      .addClass("custom-display-screen-menu-closed");
  }

  $(document).on("click", ".icon-to-manage-menu-opened", function () {
    openMenu();
  });

  function openMenu() {
    hideElement("custom-display-menu-opened", false);
    hideElement("custom-display-menu-closed", true);

    $("#div-with-page-content")
      .removeClass("custom-display-screen-menu-closed")
      .addClass("custom-display-screen-menu-open");
  }

  function changeArrow(el) {
    const arrow = el.querySelectorAll("i")[1];

    console.log(arrow, el);

    if (el.getAttribute("aria-expanded") === "true") {
      arrow.classList.remove("bi-chevron-down");
      arrow.classList.add("bi-chevron-up");
    } else {
      arrow.classList.remove("bi-chevron-up");
      arrow.classList.add("bi-chevron-down");
    }
  }

  $(document).on("click", ".list-group-item-dropdown", function (event) {
    const menuBtn = event.currentTarget;
    const toggleLink = menuBtn.querySelector('[data-bs-toggle="collapse"]');

    if (toggleLink) {
      setTimeout(() => {
        const isExpanded = toggleLink.getAttribute("aria-expanded") === "true";

        if (isExpanded) {
          menuBtn.classList.add("bg-primary", "text-white", "pb-3");
        } else {
          menuBtn.classList.remove("bg-primary", "text-white", "pb-3");
        }

        changeArrow(toggleLink);
      }, 100);
    }
  });
});
